import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'spaq-contact-form',
	template: `
		<div class="pt-2 ps-5 pe-5 pb-5">
			<div class="alert alert-success p-3 mt-4" *ngIf="hasSuccess">
				{{ 'CONTACT.FORM.SUBMIT_SUCCESS_MESSAGE' | translate }}
			</div>
			<div class="alert alert-success p-3" *ngIf="hasError">
				{{ 'CONTACT.FORM.SUBMIT_FAILURE_MESSAGE' | translate }}
			</div>
			<spaq-core-form
				*ngIf="!hasSuccess"
				[onSuccess]="this.formSuccess"
				[onError]="this.formError"
				[onUpdate]="this.update"
				[values]="values"
				[pending]="pending"
				[formGroup]="form"
				[submitValue]="'CONTACT.FORM.SUBMIT_VALUE' | translate"
			>
				<spaq-input-combo-box
					[hidden]="disableNature"
					formControlName="nature"
					[value]="0"
					class="mt-4"
					label=""
					[data]="subjects"
				></spaq-input-combo-box>

				<spaq-input-text formControlName="email" [label]="'CONTACT.FORM.EMAIL_LABEL' | translate"></spaq-input-text>
				<spaq-input-text
					[hidden]="true"
					formControlName="fullName"
					[label]="'CONTACT.FORM.FULLNAME_LABEL' | translate"
				></spaq-input-text>
				<spaq-input-text
					[hidden]="disableContractNo"
					formControlName="contractNo"
					[label]="'CONTACT.FORM.CONTRACTNO_LABEL' | translate"
				></spaq-input-text>
				<spaq-input-text
					[hidden]="disableService"
					formControlName="serviceDescription"
					[label]="'CONTACT.FORM.SERVICE_DESCRIPTION_LABEL' | translate"
				></spaq-input-text>
				<spaq-input-text
					[hidden]="disableService"
					formControlName="serviceId"
					[label]="'CONTACT.FORM.SERVICENO_DESCRIPTION' | translate"
				></spaq-input-text>
				<spaq-input-text
					[hidden]="disableService"
					formControlName="parkName"
					[label]="'CONTACT.FORM.PARKNAME_DESCRIPTION' | translate"
				></spaq-input-text>

				<spaq-input-text
					[disabled]="disableSubject"
					formControlName="subject"
					[label]="'CONTACT.FORM.SUBJECT_LABEL' | translate"
				></spaq-input-text>
				<spaq-input-textarea formControlName="body" [label]="'CONTACT.FORM.BODY_LABEL' | translate"></spaq-input-textarea>
				<small class="text-danger">
					{{ 'CONTACT.FORM.NOCC_WARNING' | translate }}
				</small>

				<div class="k-label mt-2" style="color: #000000">
					Joindre un fichier au format JPG, PNG ou PDF (Taille maximale de 10 Mo)
				</div>
				<div class="custom-file mt-2" id="customFile" lang="es">
					<input
						type="file"
						(change)="uploadFile($event)"
						accept=".jpg,.jpeg,.png,.pdf"
						class="custom-file-input"
						id="exampleInputFile"
						aria-describedby="fileHelp"
					/>
					<label class="custom-file-label" for="exampleInputFile">
						{{ 'CONTACT.FORM.FILE_LABEL' | translate }}
					</label>
				</div>
			</spaq-core-form>
		</div>
	`,
	styles: [
		`
			p {
				font-size: 1rem;
			}
		`
	]
})
export class ContactFormComponent implements OnInit {
	@Input() date = new Date().toISOString();
	@Input() disableContractNo = false;
	@Input() disableNature = false;
	@Input() disableService = false;
	@Input() disableSubject = false;
	@Output() formError = new EventEmitter();
	form: FormGroup;
	@Input() hasError = false;
	@Input() hasSuccess = false;
	@Input() pending = false;
	@Input() subjects = [];
	@Output() formSuccess = new EventEmitter();
	@Output() update = new EventEmitter();
	@Input() values = {};

	constructor(public translateService: TranslateService) {
		translateService.get('CONTACT.FORM.SUBJECT_1').subscribe((res: string) => {
			this.subjects.push(res);
		});
	}

	ngOnInit() {
		this.form = new FormGroup(
			{
				nature: new FormControl(null, [Validators.required]),
				currentDate: new FormControl(null, [Validators.required]),
				subject: new FormControl(null, [Validators.required]),
				contractNo: new FormControl(null, [Validators.required]),
				fullName: new FormControl(null, [Validators.required]),
				serviceDescription: new FormControl(null, [Validators.required]),
				parkName: new FormControl(null, [Validators.required]),
				serviceId: new FormControl(null, [Validators.required]),
				email: new FormControl(null, [Validators.required]),
				body: new FormControl(null, [Validators.required]),
				attachment: new FormControl(null, [])
			},
			{ updateOn: 'change' }
		);
	}

	uploadFile(event: any) {
		const _validFileExtensions = ['.jpg', '.jpeg', '.bmp', '.gif', '.png', '.pdf', '.txt'];

		if (event) {
			const reader = new FileReader();
			reader.readAsBinaryString(event.target.files[0]);

			const fileName = event.target.files[0].name;
			const fileType = event.target.files[0].type;

			this.form.disable();
			reader.onload = (e: any) => {
				const base64 = btoa(e.target.result);
				if (base64.length >= 10 * 1024 * 1024) {
					this.form.enable();

					this.translateService.get('CONTACT.FORM.ERR_FILE_SIZE_TOO_BIG').subscribe((res: string) => {
						alert(res);
					});

					this.form.enable();
					return;
				}
				let blnValid = false;
				for (let j = 0; j < _validFileExtensions.length; j++) {
					const sCurExtension = _validFileExtensions[j];
					if (
						fileName.substr(fileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() ===
						sCurExtension.toLowerCase()
					) {
						blnValid = true;
						break;
					}
				}

				if (!blnValid) {
					this.form.enable();
					this.translateService
						.get('CONTACT.FORM.ERR_INVALID_TYPE', { filename: fileName, extensions: _validFileExtensions.join(', ') })
						.subscribe((res: string) => {
							alert(res);
						});

					return false;
				}

				this.form.get('attachment').setValue({ ContentType: fileType, Filename: fileName, Base64Content: base64 });
				this.form.enable();
			};
			reader.onerror = _e => {
				this.form.enable();
			};
			reader.onabort = _e => {
				this.form.enable();
			};
		}
	}
}
